import React from 'react';
import cookie from 'react-cookies';

import Widget from './../widget/Widget';
import Config from './../config/Config';


class Title extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            title: props.title,
            sourcePath: Config.getSourcePath(),
        }

        this.loadDistrict = this.loadDistrict.bind(this);
    }

    componentDidMount()
    {
        Widget.loadClass();
    }

    loadDistrict() {
        let defaultDistrict, userInfo = cookie.load("_user_login_info_");

        if (userInfo.user_properties !== undefined && userInfo.user_properties.default_district !== undefined) {
            if (typeof (userInfo.user_properties.default_district) === 'string') {
                defaultDistrict = JSON.parse(userInfo.user_properties.default_district);
            }
            else {
                defaultDistrict = userInfo.user_properties.default_district;

            }

            return defaultDistrict;
        }

        return null;
    }

    reload = () => {
        this.props.history.push({ pathname: "/"});
         window.location.reload();
    }
   
    render() {
        let { title, sourcePath } = this.state;

        return (
            <div className='sf-system-title sd-system-title sg-system-title' onClick={this.reload}>
                <img style={{ minHeight: '35px' }} src={require("../img/" + sourcePath + "/login/logo.png")} />
            </div>
        )
    }
}

export default Title